import { createNavigation } from "next-intl/navigation";
import { routing } from "./routing";

/**
 * Locale-aware replacements for next/link and next/navigation: these keep the
 * active locale prefix on hrefs, so callers write `/poi/x` and get `/fr/poi/x`.
 */
export const { Link, redirect, usePathname, useRouter, getPathname } =
  createNavigation(routing);
